import { ContactInfo } from './contactInfo';
import { Address } from './address';
import { User } from './user';
import { Proposal } from './proposal';

export enum ProjectStatus {
  Open,
  Proposed,
  Closed
}

// item 164 — one assigned project lead + their % share of the project-lead
// commission. A project's leads' percents must sum to 100%.
export interface ProjectLeadAssignment {
  userId: string;
  percent: number;
}

export interface Project {
  id: string;
  name: string;
  projectId: string;
  // present on the projects-list items (ProjectIndexItemDto) — used to group by customer (item 121)
  customerName?: string;
  createdDate: string;
  customer: ContactInfo | undefined;
  customerId: string;
  description: string;
  // item 570 — required; the project's platform (managed Platforms list, feeds Sales Bible)
  platform?: string;
  // dart (2026-07-15, Chad) — NEXT_EPIC #2: project-level legal info (future contracts). Legal name +
  // address required; authorized-contact name/email optional.
  legalName?: string | null;
  // item 830 (Chad) — the property official address is now structured, like serviceAddress
  legalAddress?: Address | null;
  authorizedContactName?: string | null;
  authorizedContactEmail?: string | null;
  // item 717 — licensed-location portions; item 830: no longer collected on the project (moved
  // to the proposal). Field kept on the model for back-compat; not edited in the project form.
  licensedLocationPortions?: string | null;
  invoices: [];
  isArchived: boolean;
  isLocked: boolean;
  lastModifiedBy: ContactInfo | undefined;
  lastModifiedById: string;
  lastModifiedDate: string;
  proposals: Proposal[];
  purchaseOrders: [];
  requestedBy: string;
  salesRep: User | undefined;
  salesRepId: string;
  projectLeads?: ProjectLeadAssignment[]; // item 164 — the assigned Project Leads + % split
  developingPartnerUserId?: string; // item 188 — per-project Developing Partner (any user)
  customerProjectManagerId?: string | null; // item 225 — the customer's PM (a CustomerStaff id)
  serviceAddress?: Address;
  serviceName: string;
  status: ProjectStatus;
  // item 120: backend sends `isFavorite` (camelCased IsFavorite) — the old `favorite`
  // name never matched, so the toggle persisted but the sidebar never re-sorted/relabelled.
  isFavorite: boolean;
  // item 1166 — administrative plumbing project (sublease holders etc.): hidden from the
  // sidebar tree + KPIs; money workflows never filter on this
  isAdministrative?: boolean; // the project's OWN flag — drives the KPI money exclusion (item 1333: cascade reverted)
  isHiddenFromSidebar?: boolean; // item 1333 — project OR customer flagged; sidebar visibility ONLY, never money
  pendingSignatureCount?: number; // item 1432 — SignWell-sent papers awaiting signature
  customerIsAdministrative?: boolean; // item 1332 — the customer's own "hide from project sidebar" flag
  // item 454 — index rows carry whether the project has a live (non-cancelled)
  // subscription, driving the sidebar badge + subscriptions-only filter.
  hasSubscription?: boolean;
  workOrders: [];
  bills: [];
}

export interface ProjectsDto {
  index: Project[];
  length: number;
}
export interface ProjectDto {
  id: string,
  customerId: string,
  salesRepId: string,
  projectId: string,
  name: string,
  requestedBy: string,
  serviceName: string,
  description: string,
  serviceAddress: Address | undefined
}

export interface p extends Project {

}
